/**
 * cloudflare-overview deck — metadata only.
 *
 * A general, customer-facing overview of what Cloudflare does and why it
 * matters to a business. Outcomes-first (cost, risk, speed, consolidation).
 */
import type { DeckMeta } from "@/framework/viewer/types";

export const meta: DeckMeta = {
  slug: "cloudflare-overview",
  title: "Cloudflare: The Connectivity Cloud",
  description:
    "A general overview of what Cloudflare does and why it matters to your business.",
  date: "2026-06-04",
  author: "Miguel Caetano Dias",
  tags: ["overview", "platform", "connectivity-cloud"],
  runtimeMinutes: 10,
  // Work-in-progress: hidden from the public homepage `/` (issue #191) while
  // still accessible in the Studio (Show drafts is on by default) and by
  // direct link at /decks/cloudflare-overview. Remove when ready to publish.
  draft: true,
};
